import {
    cPoint,
    Rubbings,
    standard,
    x20_BillGates,
    x20_CryptoHayes,
    x20_cz_binance,
    x20_elonmusk,
    x20_VitalikButerin
} from "../assets";
import { CRYPTO_TOKEN } from './addresses'
import { constructSameAddressMap } from '../utils/constructSameAddressMap'
import { SupportedChainId } from './chains'

//ARB
// export const X20_FACTORY ='0x40E81Cd8bebF795093C2c853EC303488C979d17c';
// export const TEST_CRYPTO_TOKEN = "0x7A60485B6B0Db48cff8b3bcF8530e5c90CC84731";

//BASE
// export const X20_FACTORY ='0x5766aa1EC77A3c0177de63e2D1f4062A7792aAEd';
// export const TEST_CRYPTO_TOKEN = "0xb8785A92ddBD7BE200324aB03831364d5FCA150e";





export const X20_INVITER_ADDR = "X20_INVITER_ADDR";
// export const TEST_CRYPTO_TOKEN = "0xe10dFaD7285D1f5B3ec880290Ae497f674d37bDA" //POL

// export const TEST_CRYPTO_TOKEN ='0x7A93fA8f0c073db3424afba894aDB90E490ced26'

//ALL，V神，奥特曼，赵长鹏，Arthur Hayes（Bitmex创始人，黑人，喊单王，SUSHI就是他喊起来的） 0x01156e8f869b2561239adf322a1e388202cec40d
export const x20PubTokenList = [
    {
        id:0,
        name:"SOCIAL",
        symboy:"@SOCIAL(不通缩)",
        token: "0xc38327E970AE1E7958cF1C4096af0CA95Ff02E78",
        icon: "https://newcryptospace.com/favicon.png",
    },
    {
        id:1,
        name:"vitalik.eth",
        symboy:"@VitalikButerin(通缩1%)",
        token: "0x9148e52f6513dd61b7538b99aa71a2ef25729a6d",
        icon: x20_VitalikButerin,
    },
    {
        id:2,
        name:"CZ 🔶 Binance",
        symboy:"@cz_binance",
        token: "0x9b5E7C39295a1f87F4A47b2eE719D14E53730918",
        icon: x20_cz_binance,
    },
    {
        id:3,
        name:"Test Token Name",
        symboy:"Test Token Symbol",
        token: "0xcbdb2e74b01f45eac350634466799256170c81d3",
        icon: x20_CryptoHayes,
    },
    {
        id:4,
        name:"Bill Gates",
        symboy:"@BillGates",
        token: "0x7d1b33b00b7960d950c00b9183669bab3818b7b1",
        icon: x20_BillGates,
    },
    {
        id:5,
        name:"Elon Musk",
        symboy:"@elonmusk",
        token: "0x7d1b33b00b7960d950c00b9183669bab3818b7b1",
        icon: x20_elonmusk,
    },
];

export const x20CpointTokenList = [
    {
        id:-10,
        name:"C Scores",
        symboy:"Cpoints (Part for eligible address)",
        token: "0x7f5e4a77d746ef220156803832c52a0cc11e44be",
        icon: "https://pbs.twimg.com/profile_images/1748153260203229184/sXJIGMBk_400x400.jpg",
    },
    {
        id:0,
        name:"",
        symboy:"",
        token: "",
        icon: "",
    },
    {
        id:0,
        name:"",
        symboy:"",
        token: "",
        icon: "",
    },

];


export const DappsList = [
    {
        style:1,
        name:"STANDARD",
        desc:"STANDARD app",
        url: "/Standard",
        icon: standard,
        open: true
    },
    {
        style:1,
        name:"Cpoints",
        desc:"Cpoints",
        url: "/airdrop/vote",
        icon: cPoint,
        open: true
    },
    {
        style:1,
        name:"Rubbings",
        desc:"Rubbings app",
        url: "/Rubbings/eth",
        icon: Rubbings,
        open: true
    },

    {
        style:0,
        name:"Coming soon",
        desc:"",
        url: "",
        icon: "",
        open: false
    },

];
